module.exports = __webpack_public_path__ + "static/img/tendu-wall-op.3bc817c.jpg";